import { yupResolver } from '@hookform/resolvers/yup';
import { IAccountRoutingRulesMeta } from '@Modules/admin/integrationSettings/containers/forms/merchant/AccountRoutingRulesFormMeta';
import { CustomButton, CustomInputCheckBox } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import { BankCorporateInputs } from '../BankCorporateInputs';

type Props = {
  onSubmit: any,
  meta: IAccountRoutingRulesMeta,
  isLoading?: boolean,
  isSubmitting: boolean,
};

export const AccountRoutingRulesFormUI = ({ meta, onSubmit, isLoading, isSubmitting }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema),});

  const displayCheckBoxes = (inputs: string[]) => {
    return inputs.map((input, index) => {
      return (
        <CustomFormControl key={index} isLoading={isLoading} isInvalid={!!errors[meta[input as keyof IAccountRoutingRulesMeta].name]}>
          <CustomInputCheckBox meta={meta[input as keyof IAccountRoutingRulesMeta]} register={register(meta[input as keyof IAccountRoutingRulesMeta].name)} hasError={errors[meta[input as keyof IAccountRoutingRulesMeta].name]}>
            {meta[input as keyof IAccountRoutingRulesMeta].label}
          </CustomInputCheckBox>
        </CustomFormControl>
      )
    })
  }

  return (
    <>
      <CC.Heading as='h1' size={'md'} fontWeight="normal" mb="1%">
      Merchant Account Routing Rules
      </CC.Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <BankCorporateInputs isLoading={isLoading} register={register} hasError={errors} />
        <CC.Grid templateColumns={{base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)', lg: 'repeat(5, 1fr)'}} gap={3} mt="2%">
          {displayCheckBoxes(['transactionCurrencyCheckbox', 'transactionCodeCheckbox', 'paymentSchemaCheckbox'])}
        </CC.Grid>
        <CC.Flex justify={'end'} mt={'1em'}>
          <CustomButton isLoading={isSubmitting} type='submit'><FaSave style={{marginRight: '10px'}} /> Sauvegarder</CustomButton>
        </CC.Flex>
      </form>
    </>
  )
}